import * as React from 'react';
import { NavLink, withRouter, RouteComponentProps } from 'react-router-dom';
import Routes from 'src/core/Routes';
import bindAllOfThis from "src/utils/BindThisHelper";
import { Layout, Menu, Icon, Divider } from 'antd';
import '../SideNav.less';

const { SubMenu } = Menu;
const { Sider } = Layout;

class NavClass {
    public display: string;
    public menuKey: string;
    public navTo?: string;
    public iconName: string;
    public subItems?: NavClass[];
}

interface GameSideNavProps extends RouteComponentProps<{}> {
}

interface GameSideNavState {
    selectedKey: string;
    selectedParent: string;
    openKeys: string[];
}

class GameSideNav extends React.Component<GameSideNavProps, GameSideNavState> {
    menuItems: NavClass[] = [];
    constructor(props: GameSideNavProps) {
        super(props);
        bindAllOfThis(this, GameSideNav.prototype);

        this.menuItems = [
            { display: "Home", menuKey: "home", navTo: Routes.BASE_ROUTE, iconName: "home" },

            {
                display: "Grade 5", menuKey: "grade5", iconName: "minus", subItems: [
                    { display: "R - Landscaping", menuKey: "grade5R", iconName: "tablet", navTo: Routes.GAME_GRADE_5_R },
                    { display: "I - Diagnosis", menuKey: "grade5I", iconName: "tablet", navTo: Routes.DIAGNOSIS_GAME },
                    { display: "A - Collage", menuKey: "grade5A", iconName: "tablet", navTo: Routes.COLLAGE_GAME },
                    { display: "S - Job Matching", menuKey: "grade5S", iconName: "tablet", navTo: Routes.GAME_GRADE_5_S },
                    { display: "E - Colony Story", menuKey: "grade5E", iconName: "tablet", navTo: Routes.COLONY_GAME },
                    { display: "C - Sliding Puzzle", menuKey: "grade5C", iconName: "tablet", navTo: Routes.PUZZLE_SLIDER },
                ]
            }, {
                display: "Grade 4", menuKey: "grade4", iconName: "minus", subItems: [
                    { display: "R - Plumbing", menuKey: "grade4R", iconName: "tablet", navTo: Routes.PLUMBING_PLATFORMER },
                    { display: "I - University", menuKey: "grade4I", iconName: "tablet", navTo: Routes.GAME_GRADE_4_I },
                    { display: "A - Paint", menuKey: "grade4A", iconName: "tablet", navTo: Routes.PHASER_PAINT_GAME },
                    { display: "S - Diner", menuKey: "grade4S", iconName: "tablet", navTo: Routes.GAME_GRADE_4_S },
                    { display: "E - Career Fair", menuKey: "grade4E", iconName: "tablet", navTo: Routes.GAME_GRADE_4_E },
                    { display: "C - Organize Desk", menuKey: "grade4C", iconName: "tablet", navTo: Routes.ORGANIZE_DESK_GAME },
                ]
            }, {
                display: "Grade 3", menuKey: "grade3", iconName: "minus", subItems: [
                    { display: "R - Diseased Trees", menuKey: "diseasedTrees", iconName: "check", navTo: Routes.DISEASED_TREES_GAME },
                    { display: "I - X-Ray", menuKey: "xray", iconName: "check", navTo: Routes.XRAY_SLIDER },
                    { display: "A - Desert Terraform", menuKey: "grade3A", iconName: "tablet", navTo: Routes.GAME_GRADE_3_A },
                    { display: "S - Fit Five", menuKey: "fitFiveGame", iconName: "check", navTo: Routes.FIT_FIVE_GAME },
                    { display: "E - Hotel Aurora", menuKey: "grade3E", iconName: "tablet", navTo: Routes.HOTEL_AURORA_GAME },
                    { display: "C - Warehouse", menuKey: "warehouseGame", iconName: "check", navTo: Routes.WAREHOUSE_GAME },
                ]
            },

            {
                display: "Grade 2", menuKey: "grade2", iconName: "minus", subItems: [
                    { display: "R - Rocket Repair", menuKey: "rocketRepair", iconName: "check", navTo: Routes.ROCKET_REPAIR },
                    { display: "I - Program Robot", menuKey: "robot", iconName: "check", navTo: Routes.PROGRAM_ROBOT },
                    { display: "A - Ship Painting", menuKey: "shipPaint", iconName: "check", navTo: Routes.SHIP_PAINTING },
                    { display: "S - Jigsaw Puzzle", menuKey: "jigsawPuzzle", iconName: "check", navTo: Routes.JIGSAW_PUZZLE },
                    { display: "E - Space Port", menuKey: "spacePort", iconName: "check", navTo: Routes.SPACE_PORT },
                    { display: "C - Mail Delivery", menuKey: "mailDelivery", iconName: "check", navTo: Routes.MAIL_DELIVERY },
                ]
            }, {
                display: "Grade 1", menuKey: "grade1", iconName: "minus", subItems: [
                    { display: "R - Ocean Cleanup", menuKey: "oceanCleanup", iconName: "check", navTo: Routes.OCEAN_CLEANUP },
                    { display: "I - City Builder", menuKey: "cityBuilder", iconName: "check", navTo: Routes.CITY_BUILDER },
                    { display: "A - Uniform Design", menuKey: "uniformDesign", iconName: "check", navTo: Routes.UNIFORM_DESIGN },
                    { display: "S - Seek and Find", menuKey: "seekAndFind", iconName: "check", navTo: Routes.SEEK_AND_FIND },
                    { display: "E - Vending Machine", menuKey: "vendingMachine", iconName: "check", navTo: Routes.VENDING_MACHINE },
                    { display: "C - Space Pets", menuKey: "spacePets", iconName: "check", navTo: Routes.SPACE_PETS },
                ]
            }, {
                display: "Grade K", menuKey: "gradeK", iconName: "minus", subItems: [
                    { display: "R - Construction Maze", menuKey: "constructionMaze", iconName: "check", navTo: Routes.CONSTRUCTION_MAZE },
                    { display: "I - Zoo", menuKey: "zoo", iconName: "check", navTo: Routes.ZOO },
                    { display: "A - Cake Decorating", menuKey: "cakeDecorating", iconName: "check", navTo: Routes.CAKE_DECORATING },
                    { display: "S - Waiter Memory", menuKey: "waiterMemory", iconName: "check", navTo: Routes.WAITER_MEMORY },
                    { display: "E - Starball", menuKey: "starball", iconName: "check", navTo: Routes.STARBALL },
                    { display: "C - Librarian", menuKey: "librarian", iconName: "check", navTo: Routes.LIBRARIAN },
                ]
            }, {
                display: "Grade PK", menuKey: "gradePK", iconName: "minus", subItems: [
                    { display: "R - Ride Mechanic", menuKey: "rideMechanic", iconName: "check", navTo: Routes.RIDE_MECHANIC },
                    { display: "I - Fossil Finder", menuKey: "fossilFinder", iconName: "check", navTo: Routes.FOSSIL_FINDER },
                    { display: "A - Face Painting", menuKey: "facePainting", iconName: "check", navTo: Routes.FACE_PAINTING },
                    { display: "S - Find Helpers", menuKey: "findHelpers", iconName: "check", navTo: Routes.FIND_HELPERS },
                    { display: "E - Ticket Taker", menuKey: "ticketTaker", iconName: "check", navTo: Routes.TICKET_TAKER },
                    { display: "C - Grocery Bagger", menuKey: "groceryBagger", iconName: "check", navTo: Routes.GROCERY_BAGGER },
                ]
            },
        ];

        this.state = {
            selectedKey: "menu",
            selectedParent: "menu",
            openKeys: ["menu"],
        };
    }

    componentWillMount() {
        this.updateSelection();
    }

    updateSelection(newSelectedKey: string = this.props.location.pathname) {
        let parent = this.findParent(newSelectedKey);
        this.setState({
            selectedKey: newSelectedKey,
            selectedParent: (parent || { menuKey: "" }).menuKey
        });
    }

    onOpenChange(openKeys) {
        const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
        var rootSubmenuKeys = ["grade5", "grade4", "grade3", "grade2", "grade1", "gradeK", "gradePK"];
        if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            this.setState({ openKeys });
        } else {
            this.setState({
                openKeys: latestOpenKey ? [latestOpenKey] : [],
            });
        }
    }

    findParent(menuKey: string, items: NavClass[] = this.menuItems) {
        for (const item of items) {
            if (item.subItems != null && item.subItems.find(x => x.navTo === menuKey) != null) {
                return item;
            }

            if (item.navTo === menuKey) {
                return item;
            }
        }
        return null;
    }

    private generateLayout(input: NavClass | NavClass[]) {
        if (Array.isArray(input)) {
            return input.map(x => this.generateLayout(x));
        }

        if (input.subItems != null && input.subItems.length > 0) {
            return <SubMenu key={input.menuKey} title={<div><Icon type={input.iconName} /> {input.display}</div>}>
                {this.generateLayout(input.subItems)}
            </SubMenu>;
        }

        return <Menu.Item key={input.navTo}>
            <NavLink to={input.navTo}>
                <Icon type={input.iconName} /> {input.display}
            </NavLink>
        </Menu.Item>;
    }

    public render() {
        return <Sider
            width="300px"
            breakpoint="md"
            collapsedWidth="0"
            className="side-nav">
            <Menu mode="inline"
                style={{ height: '100%' }}
                onSelect={param => this.updateSelection(param.key)}
                openKeys={this.state.openKeys}
                onOpenChange={keys => this.onOpenChange(keys)}
                selectedKeys={[this.state.selectedKey]}
                defaultOpenKeys={[this.state.selectedParent]}>
                {this.generateLayout(this.menuItems)}
            </Menu>
        </Sider>;
    }
}

export default withRouter(GameSideNav);



// WEBPACK FOOTER //
// ./src/layouts/game/GameSideNav.tsx